import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BenefitsCarouselComponent} from './benefits-carousel.component';
import {OptionsNgxOwCarouselService} from 'dmmp-services';
import {CarouselModule} from 'ngx-owl-carousel-o';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TitleModule} from "../title/title.module";

@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CarouselModule,
    CommonModule,
    TitleModule
  ],
  declarations: [BenefitsCarouselComponent],
  exports: [
    BenefitsCarouselComponent
  ],
  providers: [
    OptionsNgxOwCarouselService
  ]
})
export class BenefitsCarouselModule {
}
